<template>
  <div class="holder">
    <textarea :id="id" v-model="data" class="form-control" @input="emmitEvent" :maxlength="maxlength"></textarea>
    <span class="ta counter text-muted" v-if="maxlength">{{charactersLeft}}</span>
  </div>
</template>

<script>
export default {
  name: "IcTextarea",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    v: {
      type: Object
    },
    maxlength: { type: String, default: null },
  },
  data() {
    return {
      data: this.value
    };
  },
  computed: {
    charactersLeft() {
        var char = this.data.length,
            limit = this.maxlength;

        return (char) + " / " + limit + "";
    }
  },
  methods: {
    emmitEvent(event) {
      this.$emit("input", event.target.value);
      if (this.v) {
        this.v.$touch();
      }
    }
  }
};
</script>

<style>
.ta.counter {
  margin-top: -25px;;
}
textarea.form-control {
  max-width: 100%;
  min-width: 100%;
  min-height: 10em;
}
</style>
